<template>
  <d2-container>
    <el-button type="primary" size="mini" icon="el-icon-circle-plus" @click="openDialog('add')">新增场景</el-button>
    <el-button type="primary" size="mini" icon="el-icon-chat-dot-round" style="float:right;margin-bottom:10px;" @click="goToChat">模拟聊天</el-button>
    <el-table :data="list" style="margin-top: 20px" border stripe>
      <el-table-column prop="id" label="ID" align="center" width="80" />
      <el-table-column prop="type" label="触发类型" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 0" type="success">情绪</el-tag>
          <el-tag v-else-if="scope.row.type === 1" type="info">时机</el-tag>
          <el-tag v-else-if="scope.row.type === 2" type="warning">事件</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="value" label="触发值" align="center" />
      <el-table-column prop="description" label="场景描述" align="center" />
      <el-table-column prop="flowId" label="动画场景ID" align="center" />
      <el-table-column prop="response" label="默认回复" align="center" />
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="openDialog('edit', scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 20px; text-align: right;"
      background
      layout="total, prev, pager, next, jumper"
      :total="total"
      :page-size="query.pageSize"
      :current-page="query.currentPage"
      @current-change="handlePageChange"
    />
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="500px">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="触发类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="0">情绪</el-radio>
            <el-radio :label="1">时机</el-radio>
            <el-radio :label="2">事件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="触发值" prop="value">
          <el-select v-if="form.type === 1" v-model="form.value" placeholder="请选择触发值">
            <el-option v-for="item in stateOptions" :key="item.type" :label="item.name" :value="item.type" />
          </el-select>
          <el-input v-else v-model="form.value" placeholder="请输入触发值" />
        </el-form-item>
        <el-form-item label="场景描述" prop="description">
          <el-input v-model="form.description" placeholder="请输入场景描述" />
        </el-form-item>
        <el-form-item label="动画场景" prop="flowId">
          <el-select v-model="form.flowId" placeholder="请选择动画场景">
            <el-option v-for="item in flowOptions" :key="item.key" :label="item.value" :value="item.key" />
          </el-select>
        </el-form-item>
        <el-form-item label="默认回复" prop="response">
          <el-input v-model="form.response" placeholder="请输入默认回复" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import { getBotSceneList, addBotScene, updateBotScene, deleteBotScene, getBotSceneStates } from '@/api/merchant/botScene'
import { getAnimFlowOptions } from '@/api/merchant/botAnimFlow'
export default {
  name: 'BotSceneManager',
  data () {
    return {
      list: [],
      total: 0,
      query: {
        currentPage: 1,
        pageSize: 10
      },
      dialogVisible: false,
      dialogStatus: 'add',
      form: {
        id: null,
        type: 0,
        value: '',
        description: '',
        flowId: '',
        response: ''
      },
      rules: {
        type: [{ required: true, message: '请选择触发类型', trigger: 'change' }],
        value: [{ required: true, message: '请输入触发值', trigger: 'blur' }],
        description: [{ required: true, message: '请输入场景描述', trigger: 'blur' }],
        flowId: [{ required: true, message: '请输入动画场景ID', trigger: 'blur' }],
        response: [{ required: false, message: '输入默认回复', trigger: 'blur' }]
      },
      stateOptions: [],
      flowOptions: []
    }
  },
  computed: {
    dialogTitle () {
      return this.dialogStatus === 'add' ? '新增场景' : '编辑场景'
    }
  },
  watch: {
    'form.type' (val) {
      if (val === 1) {
        this.fetchStateOptions()
        this.form.value = ''
      } else {
        this.form.value = ''
      }
    }
  },
  methods: {
    fetchList () {
      getBotSceneList({
        currentPage: this.query.currentPage,
        pageSize: this.query.pageSize
      }).then(res => {
        this.list = res.records || []
        this.total = parseInt(res.total) || 0
      })
    },
    fetchStateOptions () {
      getBotSceneStates().then(res => {
        this.stateOptions = res || []
      })
    },
    fetchFlowOptions () {
      getAnimFlowOptions().then(res => {
        this.flowOptions = res || []
      })
    },
    handlePageChange (page) {
      this.query.currentPage = page
      this.fetchList()
    },
    openDialog (status, row) {
      this.dialogStatus = status
      if (status === 'edit' && row) {
        this.form = { ...row }
        if (this.form.type === 1) {
          this.fetchStateOptions()
        }
      } else {
        this.form = { id: null, type: 0, value: '', description: '', flowId: '', response: '' }
      }
      this.dialogVisible = true
      this.fetchFlowOptions()
    },
    handleSubmit () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (this.dialogStatus === 'add') {
          addBotScene(this.form).then(() => {
            this.$message.success('新增成功')
            this.dialogVisible = false
            this.fetchList()
          })
        } else {
          updateBotScene(this.form.id, this.form).then(() => {
            this.$message.success('编辑成功')
            this.dialogVisible = false
            this.fetchList()
          })
        }
      })
    },
    handleDelete (id) {
      this.$confirm('确定要删除该场景吗？', '提示', { type: 'warning' })
        .then(() => {
          deleteBotScene(id).then(() => {
            this.$message.success('删除成功')
            this.fetchList()
          })
        })
    },
    goToChat () {
      this.$router.push({ path: '/merchant/agent/bot/leeBotChat' })
    }
  },
  mounted () {
    this.fetchList()
    this.fetchFlowOptions()
  }
}
</script>
